module.exports = __webpack_public_path__ + "static/media/waranty.83f976f5.svg";